import React, { useEffect, useState } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Popconfirm, Popover, Tooltip,
  Divider,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import H3Text from '@Uilib/h3Text';
import ShopifyIcon from '@Images/admin/integrations/shopify-icon.png';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import { LoadingOutlined } from '@ant-design/icons';
import releaseConfig from '../../../../config.json';
import { GetShopifyErrors } from '../../../modules/shopifyErrors';
import useCheckPortrait from '../../../hooks/useCheckPortrait';
import PRZText from '../../Common/UI/PRZText';
import './style.scss';

function ShopifyFailedEventsList({
  getShopifyErrorsLoading,
  shopifyErrors,
  syncShopifySOLoading,
  getShopifyErrors,
  syncShopifySO,
  history,
}) {
  const [currentPageFailed, setCurrentPageFailed] = useState(1);
  const [syncShopifyIds, setSyncShopifyIds] = useState([]);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    getShopifyErrors();
  }, []);

  const location = useLocation();

  const pushParamsToUrl = (page, pgSize) => {
    const params = new URLSearchParams(location.search);
    if (page) {
      params.set('page', page);
    }
    if (pgSize) {
      params.set('limit', pgSize);
    }
    history.push(`?${params.toString()}`);
  };

  useEffect(() => {
    pushParamsToUrl(currentPageFailed, limit);
  }, [currentPageFailed, limit]);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const getColumnsForFailedEvents = () => {
    const shopifyErrorsColumns = [
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText
                  text={record?.id}
                  className="mobile-list__card_item-number"
                />
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  className="mobile-list__card__status"
                  style={{
                    backgroundColor: record?.custom_status_info?.color_code,
                  }}
                  text={record?.custom_status_info?.status_name?.replaceAll('_', ' ').toProperCase()}
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">

                <PRZText
                  text={(
                    <span>
                      <span>Shopify Order No.: </span>
                      {record?.sales_order_info?.shopify_order_number ? (
                        <span style={{
                          fontWeight: 500,
                          color: '#1890FF',
                          cursor: 'pointer',
                        }}
                        >
                          <a
                            href={`https://admin.shopify.com/store/${record?.shopify_domain?.split('.')?.[0]}/orders/${record?.sales_order_info?.shopify_order_number}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {record?.sales_order_info?.shopify_order_number}
                          </a>
                        </span>
                      ) : '-'}
                    </span>
                  )}
                  className="mobile-list__card_item-details"
                />

                <PRZText
                  text={(
                    <span>
                      <span>Sales Order No.: </span>
                      {
                        record?.sales_order_info?.sales_order_number ? (
                          <span
                            style={{
                              fontWeight: 500,
                              color: '#1890FF',
                              cursor: 'pointer',
                            }}
                            onClick={() => history.push(`/sales/sales-order/view/${record?.sales_order_info?.order_id}`)}
                          >
                            <H3Text text={record?.sales_order_info?.sales_order_number ?? ''} />
                          </span>
                        ) : '-'
                      }
                    </span>
                  )}
                  className="mobile-list__card_item-details"
                />

                <PRZText text={`Shopify Event: ${record?.shopify_event || '-'}`} className="mobile-list__card_item-details" />

                <PRZText
                  text={(
                    <span>
                      <span>Error: </span>
                      <span>
                        {
                          (releaseConfig.environment === 'dev'
                            || localStorage.getItem('debug_mode') === 'true')
                            ? (
                              <Popover title={record?.error_info?.error}>
                                <span>{record?.error_info?.ui_message}</span>
                              </Popover>
                            )
                            : record?.error_info?.ui_message
                        }
                      </span>
                    </span>
                  )}
                  className="mobile-list__card_item-details"
                />
              </div>
            </div>

            <Divider className="mobile-list__card_divider" />

            <div className="mobile-list__card_footer">
              <div
                className="mobile-list__card_footer-left"
                style={{
                  width: '100%',
                }}
              >

                <div className="mobile-list__card_footer__actions-button_wrapper">
                  {record?.sales_order_info ? (
                    <div className="syn-shopify-button__errors">
                      <Popconfirm
                        placement="topRight"
                        title="Are you sure you want to sync this order again?"
                        onConfirm={() => {
                          setSyncShopifyIds([...syncShopifyIds, record?.id]);
                          if (record?.sales_order_info) {
                            syncShopifySO(
                              {
                                shopify_order_id: record?.id,
                                shop_name: record?.shopify_domain,
                                is_from_error_screen: true,
                              },
                              () => {
                                getShopifyErrors();
                                setSyncShopifyIds(syncShopifyIds?.filter((i) => i?.id !== record?.id));
                              },
                            );
                          }
                        }}
                        okText="Sync again"
                        cancelText="Cancel"
                      >
                        {syncShopifyIds?.includes(record?.id) && syncShopifySOLoading ? (
                          <LoadingOutlined />
                        ) : (
                          <div className="img-shopify__wrapper">
                            <img
                              src={ShopifyIcon}
                              alt="Shopify"
                              className={`img-shopify ${!record?.sales_order_info ? 'img-shopify__disabled' : ''}`}
                            />
                          </div>
                        )}
                      </Popconfirm>
                    </div>
                  ) : (
                    <div className="syn-shopify-button__errors">
                      <div className="img-shopify__wrapper">
                        <img
                          src={ShopifyIcon}
                          alt="Shopify"
                          className={`img-shopify ${!record?.sales_order_info ? 'img-shopify__disabled' : ''}`}
                        />
                      </div>
                    </div>
                  )}
                </div>

              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'ID',
        fixed: 'left',
        render: (record) => (
          <H3Text text={record?.id} />
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'SHOPIFY ORDER NO.',
        render: (record) => (
          record?.sales_order_info?.shopify_order_number ? (
            <div className="associated-entity">
              <a
                href={`https://admin.shopify.com/store/${record?.shopify_domain?.split('.')?.[0]}/orders/${record?.sales_order_info?.shopify_order_number}`}
                target="_blank"
                rel="noreferrer"
              >
                {record?.sales_order_info?.shopify_order_number}
              </a>
            </div>
          ) : (<H3Text text=" - " />)
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'SALES ORDER NO.',
        render: (record) => (
          record?.sales_order_info?.sales_order_number ? (
            <div className="associated-entity" onClick={() => history.push(`/sales/sales-order/view/${record?.sales_order_info?.order_id}`)}>
              <H3Text text={record?.sales_order_info?.sales_order_number ?? ''} />
            </div>
          ) : (<H3Text text=" - " />)
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'SHOPIFY EVENT',
        render: (record) => (
          <H3Text text={record?.shopify_event || '-'} />
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'ERROR',
        render: (record) => (
          <H3Text
            text={
              (releaseConfig.environment === 'dev'
                || localStorage.getItem('debug_mode') === 'true')
                ? (
                  <Popover title={record?.error_info?.error}>
                    <span>{record?.error_info?.message}</span>
                  </Popover>
                )
                : record?.error_info?.message
            }
          />
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: '',
        key: 'action',
        className: 'list__actions-column',
        render: (record) => (record?.sales_order_info ? (
          <div className="syn-shopify-button__errors">
            <Popconfirm
              placement="topRight"
              title="Are you sure you want to sync this order again?"
              onConfirm={() => {
                setSyncShopifyIds([...syncShopifyIds, record?.id]);
                if (record?.sales_order_info) {
                  syncShopifySO(
                    {
                      shopify_order_id: record?.id,
                      shop_name: record?.shopify_domain,
                      is_from_error_screen: true,
                    },
                    () => {
                      getShopifyErrors();
                      setSyncShopifyIds(syncShopifyIds?.filter((i) => i?.id !== record?.id));
                    },
                  );
                }
              }}
              okText="Sync again"
              cancelText="Cancel"
            >
              {syncShopifyIds?.includes(record?.id) && syncShopifySOLoading ? (
                <LoadingOutlined />
              ) : (
                <div className="img-shopify__wrapper">
                  <img
                    src={ShopifyIcon}
                    alt="Shopify"
                    className={`img-shopify ${!record?.sales_order_info ? 'img-shopify__disabled' : ''}`}
                  />
                </div>
              )}
            </Popconfirm>
          </div>
        ) : (
          <div className="syn-shopify-button__errors">
            <div className="img-shopify__wrapper">
              <img
                src={ShopifyIcon}
                alt="Shopify"
                className={`img-shopify ${!record?.sales_order_info ? 'img-shopify__disabled' : ''}`}
              />
            </div>
          </div>
        )),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
    ];
    return shopifyErrorsColumns.filter((item) => !item.hidden);
  };

  const getDataSourceForFailedEvents = () => {
    const tempData = [];
    for (let i = 0; i < shopifyErrors?.length; i++) {
      tempData.push({
        ...shopifyErrors?.[i],
        key: uuidv4(),
      });
    }
    return tempData;
  };

  return (
    <div className="doc-list__wrapper doc-list__tab-content">
      <div className="ant-row">
        <div className="ant-col-xs-24">
          <div className="doc-list__table-wrapper">
            <Table
              title={() => (
                <div className="doc-list__table-header">
                  <div className="doc-list__table-header__left">
                    {`${shopifyErrors?.length || 0} Shopify Failed Events`}
                  </div>
                </div>
              )}
              loading={getShopifyErrorsLoading}
              bordered
              showHeader
              size="small"
              pagination={
                {
                  defaultCurrent: currentPageFailed,
                  current: currentPageFailed,
                  total: shopifyErrors ? shopifyErrors?.length : 0,
                  pageSize: limit,
                  onChange: (currPage, pgSize) => {
                    setCurrentPageFailed(currPage);
                    setLimit(pgSize);
                  },
                  position: ['bottomLeft'],
                  showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                  showSizeChanger: true,
                  pageSizeOptions: [10, 25, 50, 100],
                }
              }
              columns={getColumnsForFailedEvents()}
              dataSource={getDataSourceForFailedEvents()}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ GetShopifyErrors, ShopifyIntegrationReducers }) => ({
  getShopifyErrorsLoading: GetShopifyErrors.loading,
  shopifyErrors: GetShopifyErrors.data,
  syncShopifySOLoading: ShopifyIntegrationReducers.syncShopifySOLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getShopifyErrors: (payload, callback) => dispatch(GetShopifyErrors.actions.request(payload, callback)),
  syncShopifySO: (payload, callback) => dispatch(ShopifyIntegrationActions.syncShopifySO(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShopifyFailedEventsList));
